import React, {useState} from 'react';
import PropTypes from 'prop-types';
import css from './DrawerOpenButton.scss';
import CloseInterventionSidebar from './CloseInterventionSidebar.js';
import StyledButton from '../common/StyledButton';
import {RequestHelp} from 'utils/types';

const DrawerOpenButton = (props) => {
    const [isDrawerOpen, setOpen] = useState(false);

    const openDrawer = () => {
        setOpen(true);
    }

    return (
        <div>
            <div className={css['to-do-closure-action']}>
                <StyledButton asLink aria-label={`Mark ${props.name} as complete`} onClick={openDrawer}>
                    {props.buttonText}
                </StyledButton>
            </div>
            <CloseInterventionSidebar {...props} isOpen={isDrawerOpen} onClose={() => setOpen(false)} successToastMessage={props.successToastMessage} />
        </div>
    )
}

DrawerOpenButton.propTypes = {
    name: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    successToastMessage: PropTypes.func.isRequired,
    requestHelp: RequestHelp.isRequired
}

export default DrawerOpenButton;
